export const uckTokens = {
    colors: {
        turquoise50:  '#E6FBF6',
        turquoise100: '#CCF7ED',
        turquoise200: '#99EEDB',
        turquoise300: '#66E5C9',
        turquoise400: '#4DE8CB',
        turquoise500: '#00DBB2', // main
        turquoise700: '#00B896',

        navy500: '#88AFD2',
        navy600: '#2E5D8F',
        navy700: '#003C71', // main
        navy800: '#002850',

        gray400: '#A3A2A0',
        gray600: '#8C8B88', // main
        gray800: '#706F6D',

        white:    '#FFFFFF', // main

        beige50:  '#FAFAF8',
        beige100: '#F6F5F2',
        beige200: '#F1EFEB',
        beige300: '#ECEAE5', // main
        beige400: '#D6D3C9',
        beige500: '#BFBBAD',
    }
};